import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_safety_measures_in_place'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_safety_measures_in_place',
  name: 'Does the facility have any of the following safety measures in place for fall protection?',
  description:
    'The intent of this question is to determine if the facility has fall prevention measures in place to protect workers.',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'WORKERS_USE_FALL_PROTECTION_WHEN_NEEDED',
      text: 'Workers use fall protection when needed',
      externalIds: [
        {
          id: 'hs-11--1-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FALL_PROTECTION_EQUIPMENT_IS_IN_GOOD_CONDITION',
      text: 'Fall protection equipment is in good condition',
      externalIds: [
        {
          id: 'hs-11--1-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FALL_PROTECTION_EQUIPMENT_IS_STORED_PROPERLY_IN_A_DESIGNATED_LO',
      text: 'Fall protection equipment is stored properly in a designated location',
      externalIds: [
        {
          id: 'hs-bui-6x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_ARE_TRAINED_ON_THE_PROPER_USE_OF_FALL_PROTECTION_EQUIPM',
      text: 'Workers are trained on the proper use of fall protection equipment',
      externalIds: [
        {
          id: 'hs-bui-7x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HIGH_WORKING_AREAS_HAVE_WALLS_FENCES_OR_OTHER_BARRIERS_OR_WORKE',
      text: 'High working areas have walls, fences, or other barriers (or workers wear fall protection at all times when working in these areas)',
      externalIds: [
        {
          id: 'hs-11--1-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NOT_APPLICABLE',
      text: 'Not Applicable',
      externalIds: [
        {
          id: 'hs-bui-8x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-11--1-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'WORKERS_USE_FALL_PROTECTION_WHEN_NEEDED',
                'FALL_PROTECTION_EQUIPMENT_IS_IN_GOOD_CONDITION',
                'FALL_PROTECTION_EQUIPMENT_IS_STORED_PROPERLY_IN_A_DESIGNATED_LO',
                'WORKERS_ARE_TRAINED_ON_THE_PROPER_USE_OF_FALL_PROTECTION_EQUIPM',
                'HIGH_WORKING_AREAS_HAVE_WALLS_FENCES_OR_OTHER_BARRIERS_OR_WORKE',
                'NOT_APPLICABLE',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-bui-5',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 13870,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
